'use client';

import { useJourney } from '@hc-frontend/core-ui';

export function JourneyInputs() {
  const journey = useJourney();

  return (
    <>
      <input name="journeyAlias" value={journey.journeyAlias} type="hidden" />
      <input name="journeyId" value={journey.journeyId} type="hidden" />
    </>
  );
}
